import React, { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Loader, useApi } from '@axiom/ui';
import type { AfcSubmission } from '@axiom/validation';

import { SubmissionApi } from '../api/submission-api';

const shouldRedirect = (
  submission?: AfcSubmission | null,
  submissionId?: AfcSubmission['id']
) => {
  return !!(
    submissionId &&
    (!submission || !submission.selfService || !submission.editable)
  );
};

export const SelfServiceRoute = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { submissionId } = useParams();
  const [{ data: submission } = { data: undefined }] = useApi(
    submissionId ? SubmissionApi.readSubmissionDetails(submissionId) : undefined
  );

  const redirect = shouldRedirect(submission, submissionId);

  useEffect(() => {
    if (redirect) {
      void navigate('../engagements', { replace: true });
    }
  }, []);

  return redirect ? <Loader name="self-service-loader" /> : children;
};
